var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-box"},[_c('div',{staticClass:"my-nav-breadcrumb-box"},[_c('sidebar-nav-breadcrumb')],1),_vm._v(" "),_c('dl',{staticClass:"show-flex-box-r"},[_c('dt',{staticClass:"my-home-sidebar-box"},[_c('my-sidebar-nav')],1),_vm._v(" "),_c('dd',{staticClass:"my-home-content-box"},[_c('router-view',{key:_vm.$route.fullPath})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b3a01e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/my/my_home.vue
// module id = null
// module chunks = 